<template>
    <project-step-container
            prev-to="rapid_experiments_with_customers_13"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject(redirection)"
    >
        <b-row>
            <b-col cols="12" class="main-text" tabindex="0">
                {{getMessage(14, 'rapidexperiment-sub')}}
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12">
                <LinkStyleGuide @open-url="openGuide" icon-name="icon-guide" :text="getMessage(14, 'rapidexperiment-guide')" />
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12" class="mt-3">
                <label for="first-thing"> {{getMessage(14, 'firstAssumption')}}</label>
                <input id="first-thing" type="text" v-model="form.firstAssumption"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="second-thing">{{getMessage(14, 'secondAssumption')}}</label>
                <input id="second-thing" type="text" v-model="form.secondAssumption"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="third-thing">{{getMessage(14, 'thirdAssumption')}}</label>
                <input id="third-thing" type="text" v-model="form.thirdAssumption"/>
            </b-col>
        </b-row>
        <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
    import {Steps} from '../Utils'
    import {ConflictSyn, Project, Storage, StyleGuides} from "../../../core/Utils"
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide";

    export default {
        name: "RapidExperimentsWithCustomers14",
        components: {ProjectStepContainer, LinkStyleGuide, ProjectStyleGuide},
        data() {
            return {
                step: Steps.FORM_LOF_ASSUMPTIONS,
                urlNextProject: 'rapid_experiments_with_customers_15',
                styleGuide: StyleGuides.getStyleGuide(StyleGuides.LEAP_FAITH_ASSUMPTIONS),
                form: {
                    firstAssumption: "",
                    secondAssumption: "",
                    thirdAssumption: ""
                }
            }
        },
        mounted() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step]
        },
        methods: {
            openGuide() {
                this.$bvModal.show('project-style-guide')
            },
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection() {
                const index = this.$route.params.index
                this.$router.push({name: this.urlNextProject, params: {index}})
            }
        }
    }
</script>